import React, { useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import TopBar from "./TopBar";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "./ui/toaster";
import { resolveRedirect } from "../seo";

const Layout = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const redirect = resolveRedirect(pathname);
  if (redirect) return <Navigate to={`${redirect}${search}`} replace />;

  return (
    <div className="App min-h-screen flex flex-col bg-brand-cream">
      <TopBar />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Layout;
